// extracted by mini-css-extract-plugin
module.exports = {"container":"ScommesseAccordion_container__QR7wa","isClickedInside":"ScommesseAccordion_isClickedInside__LN9ZM","item":"ScommesseAccordion_item__FP_td"};